import Column from '@components/Column';
import Divider from '@components/Divider';
import Header from '@components/Header';
import useProject from '@hooks/useProject';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';

import Agreements from './components/Agreements';
import Certification from './components/Certification';
import SignUpButton from './components/SignUpButton';
import SignUpContextProvider from './context/SignUpContextProvider';
import styles from './styles.module.scss';

interface Params {
    appleId?: string;
    kakaoId?: number;
    nickname?: string;
}

const SignUpActivity: ActivityComponentType<Params> = ({ params }:{params:Params }) => {
  const { appleId, kakaoId, nickname } = params;
  const project = useProject();
  return (
        <SignUpContextProvider appleId={appleId}
                               kakaoId={kakaoId}
                               nickname={nickname} >
            <AppScreen>
                <Column fullWidth fullHeight>
                    <Header title='회원가입' />
                    <div className={styles.contents}>
                        {(!project?.features.authenticationEnabled) && (
                            <Fragment>
                                <Certification/>
                                <Divider/>
                            </Fragment>
                        )}
                        <Agreements/>
                    </div>
                    <SignUpButton/>
                </Column>
            </AppScreen>
        </SignUpContextProvider>
  );
};

export default SignUpActivity;
